import { FinalTableConfig } from "@beeldit/core/models/FinalTableConfig.interface";
import { Receipt } from "@phosphor-icons/react";

const tableConfig: FinalTableConfig = {
  index: null,
  actions: [
    {
      name: "generate-invoices",
      label: "generate_invoices",
      icon: <Receipt size={20} />,
      variant: "primary",
      className: "",
      show: true,
      showLabel: true,
      roles: ["admin", "tenant_admin"],
      // permissions se omite a propósito: checkPermissions devuelve false con un array vacío.
      action: () => {},
    },
  ],
  rowActions: [
    
  ],
  rowConfiguration: {
    class: (element: any) => {
      return null;
    },
  },
  columns: [
    {
      name: "id",
      label: "#",
      key: "id",
      type: "number",
      show: true,
      allowOrder: true,
    },
    {
      name: "producer",
      label: "producer",
      key: "emitter.user.name" ,
      type: "string",
      show: true,
      allowOrder: true,
    },
    {
      name: "order_amount",
      label: "order_amount",
      key: "concept.total_price" ,
      type: "currency",
      currency: "EUR",
      show: true,
      allowOrder: true,
    },
    {
      name: "commission_amount",
      label: "commission_amount",
      key: "concept.commission_amount" ,
      type: "currency",
      currency: "EUR",
      show: true,
      allowOrder: true,
    }
  
  ],
  pagination: {
    enabled: true,
    back: true,
  },
};
const getConfig: any = (functions: any) => {
  const {
    getFunction,
    indexFunction,
    initializeFunction,
    prepareRemoveFunction,
    importFunction,
    exportFunction,
    generateInvoicesFunction,
    commerce
  } = functions;
  if (tableConfig.actions[0] && generateInvoicesFunction) {
    tableConfig.actions[0].action = () => generateInvoicesFunction();
  }
  tableConfig.index = () => indexFunction();
  // tableConfig.rowActions[0].action = (id: any) => getFunction(id);
  // tableConfig.rowActions[1].action = (id: any) => prepareRemoveFunction(id);
  // tableConfig.columns[4].currency = commerce ? commerce.currency : 'EUR';

  return tableConfig;
};
export default getConfig;
